import { initializeApp, getApps } from 'firebase/app';
import type { AnalyticsEvent, AnalyticsEventParams } from './types';
import { localeFromPath } from './locales';

type ActiveAnalytics = {
  analytics: import('firebase/analytics').Analytics;
  logEvent: typeof import('firebase/analytics').logEvent;
};

let analyticsPromise: Promise<ActiveAnalytics | undefined> | undefined;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export function enableAnalytics() {
  if (analyticsPromise) return analyticsPromise;
  if (!firebaseConfig.apiKey || !firebaseConfig.appId || !firebaseConfig.measurementId) {
    return Promise.resolve(undefined);
  }
  analyticsPromise = import('firebase/analytics').then(async ({ getAnalytics, isSupported, logEvent }) => {
    if (!(await isSupported())) return undefined;
    const app = getApps()[0] ?? initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    logEvent(analytics, 'page_view', { page_location: window.location.href, language: localeFromPath() });
    return { getAnalytics, logEvent, analytics };
  });
  return analyticsPromise;
}

export function track(event: AnalyticsEvent, params: AnalyticsEventParams = {}) {
  void analyticsPromise?.then((module) => module?.logEvent(module.analytics, event, { ...params, language: localeFromPath(), ...utmParams() }));
}

function utmParams() {
  const search = new URLSearchParams(window.location.search);
  return Object.fromEntries([...search.entries()].filter(([key]) => key.startsWith('utm_')));
}
